import React, { useState, useRef, useEffect, useMemo } from "react";
import PropTypes, { element, number } from "prop-types";
import DatePicker from "react-modern-calendar-datepicker";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import Icon from "../../elements/icon";
import RadioButtonGroup from "../../elements/radio-button-group";
import { lorem } from "../../utils/lorem";
import classNames from "classnames";
import "./style.scss";

import moment from "moment";
const CalendarDatePicker = ({ okButton, cancelLink, onDateSelect, openToDate, showTime = false, availableTimeSlots = [], onTimeSlotSelect, noSlotsText, disablePreviousDates = true }) => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [newRef, setNewRef] = useState(useRef(null));
  const [isOpen, toggleOpen] = useState(false);
  const [currentDateIndex, setCurrentDateIndex] = useState(0);
  const [timeSlotsToShow, setTimeSlots] = useState(null);
  const [tempdDay, setTempDay] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  
  useEffect(() => {
    setCurrentDateIndex(availableTimeSlots.findIndex(i => i.date?.day === selectedDay?.day && i.date?.month === selectedDay?.month && i.date?.year === selectedDay?.year))
  }, [selectedDay])

  const maximumDate = useMemo(() => {
    if (availableTimeSlots.length === 0) {
      return null;
    }
    return availableTimeSlots[availableTimeSlots.length - 1].date;
  }, [availableTimeSlots]);
  const mininumDate = useMemo(() => {
    if (availableTimeSlots.length === 0) {
      return null;
    }
    return availableTimeSlots[0].date;
  }, [availableTimeSlots]);
  const wrapperRef = useRef(null);
  const initSates = ref => {
    setNewRef(ref);
    if (isOpen) {
      toggleOpen(prev => {
        return false;
      });
      closeCalendar(ref);
    } else {
      toggleOpen(prev => {
        return true;
      });
      ref.current.focus();
      let element = document.getElementsByClassName("DatePicker__calendarContainer");
      if (element && element[0]) element[0].style.display = "block";
    }
    onDateChange(selectedDay);
    onDateSelect && onDateSelect(selectedDay);
  };
  const onDateChange = (date, showSlots = true) => {
    setSelectedDay(prev => {
      return date;
    });
    setTimeSlots(null);
    if (availableTimeSlots.length > 0) {
      const slots = availableTimeSlots.findIndex(el => el.date.day === date.day && el.date.month === date.month && el.date.year === date.year);
      if (slots > -1) {
        setTimeSlots(availableTimeSlots[slots].timeSlots);
        setSelectedTime(availableTimeSlots[slots].timeSlots[0]);
        onTimeSlotSelect(availableTimeSlots[slots].timeSlots[0]);
      } else {
        setSelectedTime(null);
        onTimeSlotSelect(null);
      }
    }
  };
  const closeCalendar = ref => {
    ref.current && ref.current.blur();
    document.getSelection().removeAllRanges();
    let element = document.getElementsByClassName("DatePicker__calendarContainer");
    if (element && element[0]) element[0].style.display = "none";
    toggleOpen(prev => {
      return false;
    });
  };
  const cancelSelection = ref => {
    ref.current && ref.current.blur();
    toggleOpen(false);
  };
  const toPreviousDate = () => {
    if (availableTimeSlots.length > 0 && currentDateIndex > 0) {
      setSelectedDay(() => {
        return availableTimeSlots[currentDateIndex - 1].date;
      });
      setCurrentDateIndex(prevIndex => {
        return prevIndex - 1;
      });
      onDateChange(availableTimeSlots[currentDateIndex - 1].date);
      onDateSelect && onDateSelect(availableTimeSlots[currentDateIndex - 1].date);
    }
  };
  const toNextDate = () => {
    if (availableTimeSlots.length > 0 && currentDateIndex !== availableTimeSlots.length - 1) {
      setSelectedDay(() => {
        return availableTimeSlots[currentDateIndex + 1].date;
      });
      setCurrentDateIndex(prevIndex => {
        return prevIndex + 1;
      });
      onDateChange(availableTimeSlots[currentDateIndex + 1].date);
      onDateSelect && onDateSelect(availableTimeSlots[currentDateIndex + 1].date);
    }
  };
 
  
  useEffect(() => {
    if (!selectedDay) setSelectedDay(openToDate);
    if (!selectedDay && availableTimeSlots.length > 0) {
      setSelectedDay(availableTimeSlots[0].date);
      setCurrentDateIndex(0);
      setTimeSlots(availableTimeSlots[0].timeSlots);
      setSelectedTime(availableTimeSlots[0].timeSlots[0]);
      onTimeSlotSelect(availableTimeSlots[0].timeSlots[0]);
    }
    toggleOpen(false);
  }, [openToDate, availableTimeSlots]);

  const labelClass = classNames({
    "in-active": isOpen
  });
  const previousArrowIconClass = classNames("arrow_icon", {
    "--disable": currentDateIndex === 0
  });
  const nextArrowIconClass = classNames("arrow_icon", {
    "--disable": currentDateIndex === availableTimeSlots.length - 1
  });

  const containerClasses = classNames("calendar-container", {
    "handle-twenty-slots": timeSlotsToShow && timeSlotsToShow.length > 20,
    "handle-slots": showTime === true
  });
  const handleClickOutside = event => {
    if (
      (isOpen &&
        wrapperRef.current &&
        event.target.className !== "buttonText" &&
        event.target.className !== "Calendar__day -ltr " &&
        event.target.className !== "Calendar__day -ltr  -disabled" &&
        event.target.className !== "Calendar__day -ltr  -weekend" &&
        event.target.className !== "primary-button  primary auto") ||
      (wrapperRef.current.className === "calendar-container handle-slots" && event.target.className === "available-slots-container")
    ) {
      toggleOpen(prev => {
        return false;
      });
      setSelectedDay(null);
      onDateChange(selectedDay);
      onDateSelect && onDateSelect(selectedDay);
    }
    if (event.target.className === "Calendar__day -ltr " || event.target.className === "Calendar__day -ltr  -weekend") {
      toggleOpen(prev => {
        return false;
      });
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, [isOpen]);
  const OnTimeSlotChange = data => {
    setSelectedTime(data);
    onTimeSlotSelect && onTimeSlotSelect(data);
  };
  const renderCustomInput = ({ ref, onFocus, onBlur }) => {
    return (
      <div className="custom-container">
        <div className="date-bar" ref={ref}>
          <div className="calendar-icon">{/* <Icon svg={lorem.svgs.calendar.svg} onClick={onFocus} /> */}</div>
          <div className="current-date-cont">
            <Icon name="ArrowLeft" onClick={() => toPreviousDate()} className={previousArrowIconClass} />
            <span
              className="date-text"
              onClick={() => {
                initSates(ref);
              }}
            >
              {selectedDay && moment(selectedDay.day + " " + selectedDay.month + " " + selectedDay.year, "DD M YYYY").format("DD MMM YYYY")}
            </span>
            <Icon name="ArrowRight" onClick={() => toNextDate()} className={nextArrowIconClass} />
          </div>
        </div>
        <div
          className="custom-input"
          onClick={e => {
            e.preventDefault();
            initSates(ref);
          }}
        >
          <label className={labelClass}>
            <input
              readOnly
              type="text"
              onClick={() => initSates(ref)}
              ref={ref} // necessary
              className="my-custom-input-class" // a styling class
            />
          </label>
        </div>
      </div>
    );
  };

  return (
    <div className={containerClasses} ref={wrapperRef}>
      <DatePicker
        value={selectedDay}
        onChange={onDateChange}
        shouldHighlightWeekends
        renderInput={renderCustomInput}
        minimumDate={disablePreviousDates && mininumDate}
        maximumDate={maximumDate}
        onMonthSelect={() => alert("yes")}
        wrapperClassName="responsive-calendar"
        renderFooter={() => (
          <div className="footer-buttons">
            <SimpleLink
              {...{
                ...cancelLink,
                callback: () => {
                  cancelSelection(newRef);
                }
              }}
            />
            <PrimaryButton
              {...{
                ...okButton,
                callback: () => {
                  closeCalendar(newRef);
                }
              }}
            />
          </div>
        )}
      />
      <div className="available-slots-container">
        {showTime !== false && timeSlotsToShow ? (
          <RadioButtonGroup options={timeSlotsToShow} selectedOption={selectedTime} onChange={data => OnTimeSlotChange(data)} />
        ) : (
          showTime !== false && (
            <div className="no-slots-available">
              <span className="text">{noSlotsText}</span>
              <span className="report-icon">
                <Icon name="Report" />
              </span>
            </div>
          )
        )}
      </div>
    </div>
  );
};
CalendarDatePicker.propTypes = {
  okButton: PropTypes.object,
  cancelLink: PropTypes.object,
  onDateSelect: PropTypes.func,
  openToDate: PropTypes.shape({
    day: PropTypes.number,
    month: PropTypes.number,
    year: PropTypes.number
  }),
  showTime: PropTypes.bool,
  availableTimeSlots: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.shape({ day: PropTypes.number, month: PropTypes.number, year: PropTypes.number }),
      timeSlots: PropTypes.arrayOf(
        PropTypes.shape({
          startTime: PropTypes.string,
          endTime: PropTypes.string,
          label: PropTypes.string,
          value: PropTypes.string
        })
      )
    })
  ),
  onTimeSlotSelect: PropTypes.func,
  noSlotsText: PropTypes.string,
  disablePreviousDates: PropTypes.bool
};
export default CalendarDatePicker;
